export const load = () => ({
	title: 'The Many Benefits Of Indow Window Inserts',
	description:
		'Window inserts solve most of the problems caused by poorly insulated windows. Explore the many different solutions that Indow inserts can provide to make your home more comfortable, quiet, & energy efficient.',
	showTitle: false,
});
